<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <v-row class="pa-2" no-gutters>
        <custom-popup
          v-model="ready"
          :cons="{ title: $t('ready_card_samples') }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-sample-ready-card-visit-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('ready_card_sample')"
            />
          </template>
        </custom-popup>

       
        <v-col cols="12" v-if="showGatewayPopup">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="specialInfoSingle"
            :form-data="multiCard"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="loading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <v-tabs-items
                  v-model="qrShow"
                  class="overflow-visible mb-4 mb-md-0"
                  touchless
                >
                  <v-tab-item> </v-tab-item>

                  <v-tab-item>
                    <view-multi-card :value="multiCard" :qr-svg-data-url="qrSvgDataUrl"/>
                  </v-tab-item>
                  <v-tab-item>
                    <component :is="theme" v-model="multiCard" :data="multiCard" />
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>

        <template v-if="!showGatewayPopup">
          <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          </v-col>

          <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

          <v-col
            class="pa-2 sticky-md"
            cols="12"
            md="4"
            style="top: 110px; height: fit-content"
          >
            <v-tabs-items
              v-model="qrShow"
              class="overflow-visible mb-4 mb-md-0"
              touchless
            >
              <v-tab-item> </v-tab-item>

              <v-tab-item>
                <view-multi-card :value="multiCard" :qr-svg-data-url="qrSvgDataUrl"/>
              </v-tab-item>
              <v-tab-item>
                <component :is="theme" v-model="multiCard" :data="multiCard" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>

          <v-col class="pa-2 px-0" cols="12" md="8">
            <v-row class="pa-2" justify="start" style="width: 100%">
              <v-col
                cols="12"
                sm="12"
                md="6"
                class="box"
                v-if="e6 === 1 && showconnect"
              >
                <v-text-field
                  v-model="connectionCode"
                  class="connect rounded-lg compact-text-field"
                  dense
                  :label="$t('connection_code')"
                  outlined
                  clearable
                >
                </v-text-field>
              </v-col>

              <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
                <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                  <v-row no-gutters>
                    <v-col class="pa-2" cols="12">
                      <p>ویرایش کردن اطلاعات کارت مولتی</p>
                    </v-col>

                    <v-col class="pa-2 d-flex row rowinfo" cols="12" md="6">
                      <v-text-field
                        v-model="res.title"
                        :disabled="e6 > 1"
                        :error-messages="errors['title']"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام مولتی کارت"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-visitName`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('visit_card_name')"
                      />
                    </v-col>

                    <v-col class="pa-2 rowinfo" cols="12" md="6">
                      <qr-address-field
                        id="qr-address"
                        ref="address-field"
                        v-model="res.identifier"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="ma-0 pa-0 contentinfo"
                        width="88%"
                        dense
                        outlined
                        persistent-hint
                        @updateDest="domainId = $event"
                        readonly
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"

                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-dtUrl`"
                        :label="$t('qr_address')"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                      />
                    </v-col>
                  </v-row>
                </v-stepper-step>
                <v-stepper-content step="1">
                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="qrUpdate(false)"
                    />
                  </div>
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
                  {{ $t("info") }}
                </v-stepper-step>
                <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                  <div class="d-flex row mx-2 mt-3 mb-4 justify-start doublebtn">
                    <help-info
                      class="buttoninfo mx-0"
                      :element-name="`${serviceName}-${componentName}-clearDefaults`"
                      :label="$t('remove_default_info')"
                      :service-name="serviceName"
                      :help-data="helpData"
                    />
                  </div>
                                    <div class="mb-4 mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

                  <list-expansion
                    v-model="multiCard"
                    :components="specialInfo"
                    :data="multiCard"
                    flat
                    @save-required="AutoSave && qrUpdate(false)"
                  />

                  <div class="col-md-12">
                    <next-btn
                      :loading="loading"
                      style="background: #1b8d39"
                      @click="qrUpdate(true)"
                    />
                  </div>
                </v-stepper-content>
              </v-stepper>

              <div class="d-none">
                <!-- <qr-code-make
                  ref="qrCanvas"
                  v-model="qrDesign"
                  :file.sync="qrSvgDataUrl"
                  :link="fullLink"
                  @save="qrDesign = $event"
                /> -->
              </div>
            </v-row>
          </v-col>
        </template>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import QrGenerator from "@/view/pages/qrland/components/qrGenerator";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import VisitThemeTwo from "@/view/pages/qrland/components/themes/visitThemeTwo";
import ThemeSelector from "@/view/pages/qrland/components/themes/themeSelector";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import MobileViwer from "@/view/pages/qrland/components/mobileViwer.vue";
import DownloadFile from "@/view/pages/qrland/downloadFile.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import ViewMultiCard from "@/view/pages/multiCart/viewMultiCard.vue";
import QrEditGateway from "../qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editMultiCard",

  components: {
    ViewMultiCard,
    QrCodeMake,
    PreparedCards,
    ThemeSelector,
    VisitThemeTwo,
    VisitThemeFlipped,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    MobileViwer,
    QrEditGateway, 
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:false,
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true', 
      loading: false,
      ready: false, 
      showconnect: false, 
      connectionCode: "", 
      multiCard: {
        language: "fa",
        langs: {
          source_lang: "fa",
          other_langs: [],
        },
        infoUser: {
          nameCollection: "",
          subTitle: "",
          logoImage: "/media/defaults/qrLogo.webp",
          background: "/media/defaults/visitFirstDefault.webp",
        },
        cardBank: {
          list: [],
        },
        visitName: "",
        pallete: {
          bodyColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
          textColor: "#EBCB63FF",
          buttonColor: "linear-gradient(to top right , #AA7630FF, #EBCB63FF)",
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },

      res: {
        title: "",
        identifier: "",
        domain: { name: "" },
        qrId: null,
      },
      helpData: [],
      componentName: "multicard",
      serviceName: "Qrland",
      qrDesign: {},
      e6: 2,
      errors: {},
      dtUrl: null,
      domainId: null,
      qrShow: 1, // تب دیفالت روی 1
      qrSvgDataUrl: "",
      theme: "",
      currentEditingLang: "fa",
    };
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.updateTransition();

    Bus.$on("showconnect", (val) => {
      this.showconnect = val;
    });

    this.$root.$on("editvisit-lang-change", (lang) => {
      this.currentEditingLang = lang;
    });

    // سوییچ اتوماتیک تب در حالت Gateway در صورت نیاز
    if (this.showGatewayPopup) {
      this.qrShow = 1; 
    }

    this.fetchData();
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
        this.updateTransition();
      }
    },
  },

  computed: {
    ...mapGetters("localstorage", ["createQrID", "alllangs", "defaultLang"]),

    specialInfo() {
        return [
          {
            name: "AddAccount",
            value: "",
            title: this.$t(
              "edit_bpage_special_info_special.add_user_information"
            ),
            subtitle: "",
            icon: "account-outline",
            model: "infoUser",
          },
          {
            name: "ManagementAccount",
            value: "",
            title: this.$t(
              "edit_bpage_special_info_special.manage_accounts"
            ),
            subtitle: "",
            model: "cardBank",
            icon: "credit-card-outline",
          },
          {
            name: "ManagementColor",
            title: this.$t(
              "edit_bpage_special_info_special.manage_color"
            ),
            icon: "palette",
            model: "pallete",
          },
        ];
      },

specialInfoSingle() {
  const descriptionKeys = {
    AddAccount:
      "edit_multicard_special_info_single.add_account_description",

    ManagementAccount:
      "edit_multicard_special_info_single.management_account_description",

    ManagementColor:
      "edit_multicard_special_info_single.management_color_description",
  };

  return this.specialInfo.map((item) => {
    const descriptionKey = descriptionKeys[item.name];

    return {
      ...item,
      description: descriptionKey ? this.$t(descriptionKey) : "",
    };
  });
},

    fullLink() {
      return (
        this.res.domain?.name?.replace("/", "") + "/" + this.res.identifier
      );
    },

    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },

    qrIdParam() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setLangList",
      "setDefaultLang",
      "setMainData",
    ]),

    // متدهای مربوط به Gateway
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    updateTransition() {
      if (this.multiCard) this.multiCard.visitName = "مولتی کارت شما";
    },

    fetchData() {
      this.loading = true;
      const url = `/v1/testQr/find/${this.domainName}${
        this.qrIdParam ? "/" + this.qrIdParam : ""
      }`;

      this.$api
        .get(url)
        .then(({ data }) => {
          const responseData = data.data;
        this.qrSvgDataUrl= data?.data?.img_url||''; 

          this.setCreatedQrID(responseData.id);

          this.setLangList(
            responseData?.lang
              ?.split(",")
              ?.filter((l) => l !== responseData?.default) || [],
          );
          this.setDefaultLang(responseData?.default || "fa");

          let info = responseData.data;
          const currentLang =
            this.defaultLang || getLanguageCookie() || info.language || "fa";

          this.currentEditingLang = currentLang;
          this.$root.$emit(
            "mobile-viewer-lang-change",
            this.currentEditingLang,
          );

          if (info.data) {
            info.data.language = currentLang;
            info.data.langs = {
              source_lang:
                this.defaultLang || info.data.langs?.source_lang || "fa",
              other_langs:
                this.alllangs?.map((x) => ({ lang: x, status: "edited" })) ||
                [],
            };
          }

          this.res = responseData;
          this.res.language = currentLang;

          this.multiCard = { ...info.data };
          this.theme = info.theme || "";

          this.setMainData({
            data: {
              data: this.multiCard,
              theme: this.theme,
              lang: this.multiCard.language,
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      this.errors = {};
      const currentLang = this.currentEditingLang;
      const sourceLang = this.multiCard.langs?.source_lang || "fa";

      const data = new URLSearchParams();

      data.append("type", "multicard");
      data.append("qrType", "dynamic");
      data.append("title", this.res.title);
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);

      if (this.res.qrId) {
        data.append("qr_id", this.res.qrId);
      }

      this.multiCard.language = this.defaultLang || getLanguageCookie() || "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.multiCard,
        }),
      );

      if (currentLang === sourceLang) {
        return this.saveToMainQr(data, final);
      } else {
        let content = {
          data: {
            data: this.multiCard,
            theme: this.theme,
          },
        };
        return this.saveToLangFtp(currentLang, final, content);
      }
    },

    saveToMainQr(data, final) {
      return this.$api
        .put("/v1/testQr/update", data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then(() => {
          if(final || !this.isAutoSaving)
          this.$toast.success("مولتی کارت شما با موفقیت ویرایش شد");
          if (final) this.goto("qr.list");
          this.e6 = 2;
        })
        .catch((err) => {
          console.error(err);
          const msg = err.response?.data?.message || "خطا در ویرایش";
          this.$toast.error(msg);
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    saveToLangFtp(lang, final, content) {
      const allLangs_1 = [this.defaultLang || "fa", ...this.alllangs];

      return this.$api
        .post(`/v1/testQr/update-lang-data/${this.createQrID}`, {
          lang: lang,
          data: content,
          langs: allLangs_1,
        })
        .then(() => {
          this.$toast.success(this.$t("language.saved"));
          if (final) this.goto("qr.list");
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("خطا در ذخیره زبان");
        })
        .finally(() => (this.loading = false));
    },

    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      if (this.multiCard.infoUser) {
        this.multiCard.infoUser.nameCollection = "";
        this.multiCard.infoUser.subTitle = "";
      }
      this.multiCard.apiKey = "";
    },

    goto(pathName) {
      this.$router.push({ name: pathName });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}

.help-info-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 1px;
}

qr-address-field {
  width: 88% !important;
}

.warp {
  position: relative;
  overflow: visible !important;
  min-height: 50px;
}

.doublebtn {
  gap: 8px;
}

.connect >>> .v-input__append-outer {
  display: flex;
  align-items: center;
  margin: 0 !important;
  padding: 0 5px 0 5px !important;
}

.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
